import { Link } from 'react-router-dom';

function Navbar() {
    return (
        <div className="">
            <header className="body-font fixed bg-dark w-full shadow z-50 top-0">
                <div className="container mx-auto flex px-5 py-3 items-center justify-center space-x-3 md:justify-between">
                    <div className="brand">
                        <Link to="/" className="flex items-center font-semibold font-title">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                className="w-10 h-10 text-white p-2 bg-red-600 rounded-full"
                                viewBox="0 0 24 24"
                            >
                                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
                            </svg>
                            <span className="ml-3 text-xl">Rakibul Islam</span>
                        </Link>
                    </div>
                </div>
            </header>
        </div>
    );
}

export default Navbar;
